module.exports = __webpack_public_path__ + "static/media/mob-conan-bg.7de37589.jpg";